import type { FlowStep } from "@zworks/console-contracts";

function stepKey(step: FlowStep): string {
  return `${step.name}|||${step.kind}|||${step.gate ? "gate" : "step"}`;
}

export type StepChange = "added" | "removed" | "unchanged";

/**
 * The per-step rows of the version diff, in the order the newer version lists them.
 * A step matches when its name, kind, and gate flag all agree.
 */
export function diffSteps(
  older: FlowStep[],
  newer: FlowStep[],
): { step: FlowStep; change: StepChange }[] {
  const oldKeys = new Set(older.map(stepKey));
  const newKeys = new Set(newer.map(stepKey));
  const rows: { step: FlowStep; change: StepChange }[] = newer.map((step) => ({
    step,
    change: oldKeys.has(stepKey(step)) ? "unchanged" : "added",
  }));
  for (const step of older) {
    if (!newKeys.has(stepKey(step))) rows.push({ step, change: "removed" });
  }
  return rows;
}
